// extracted by mini-css-extract-plugin
export default {"tag":"LastIntegrationTag_tag__az9C8"};